import { FIELDS_NAMES, REQUIRED_FIELDS } from "../constants";
import { MetadataType } from "../types";

type ImageMetadataValidation = {
    hasError: boolean;
    errors: Record<string, string>;
};
export function validateImageMetadata(imageMetadata: MetadataType): ImageMetadataValidation {
    let hasError = false;
    const errors: Record<string, string> = {};

    REQUIRED_FIELDS.forEach((field) => {
        if (!imageMetadata[field]) {
            hasError = true;
            errors[field] = `${FIELDS_NAMES[field]} is required`;
        }
    });

    return {
        hasError,
        errors,
    };
}